import { V1User } from './user';
import { V1Workspace } from './workspace';

type Repository = {
  name: string;
  owner: V1User | V1Workspace;
  slug: string;
};

declare global {
  namespace BB {
    type V1Repository = Repository;
  }
}

export type V1Repository = Repository;
